import { render } from "./ConfigRoundDeleteDialog.vue?vue&type=template&id=4ca3b82b"
import script from "./ConfigRoundDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfigRoundDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__